<template lang="pug">
  .b-spec-ai-indicator(v-if="jobs.length")
    ._job(
      v-for="job in jobs"
      :key="job.id"
      data-testid="spec-ai-indicator"
      :data-job-type="job.type"
      :class="{ error: job.status === 'error' }"
      )
      ._spinner(v-if="inProgress(job)")
      ._status(data-testid="spec-ai-indicator-status") {{ statusText(job) }}
      button._action(v-if="resultLabel(job)" type="button" data-testid="spec-ai-result" @click="$emit('result', job)") {{ resultLabel(job) }}
      button._action(v-if="hasFailed(job)" type="button" data-testid="spec-ai-retry-failed" @click="$emit('retry', job)") Повторить по ошибочным
      button._action(v-if="inProgress(job) && !readOnly" type="button" data-testid="spec-ai-cancel" @click="$emit('cancel', job)") Отменить
      button._dismiss(v-if="!inProgress(job)" type="button" data-testid="spec-ai-dismiss" title="Скрыть" @click="$emit('dismiss', job)") ×
</template>

<script>
import model from '@/model/specification';

/**
 * Индикатор заданий AI в шапке спецификации (ТЗ 5.1, 6.2): по строке на задание — заданий может
 * быть несколько одновременно (ТЗ 4.1). В строке — «в обработке», «Готово», «Готово частично: … ,
 * ошибка по K», «ошибка: …»; ссылка на результат для импорта и фото, кнопка «Повторить по
 * ошибочным», «Отменить» у задания в работе и «×» у завершённого. Сгенерировано Claude.
 */
export default {
  name: 'SpecAiIndicator',
  props: {
    jobs: { type: Array, default: () => [] },
    readOnly: Boolean,
  },
  methods: {
    inProgress(job) {
      return ['queued', 'processing'].includes(job.status);
    },
    statusText(job) {
      return model.jobStatusText(job);
    },
    resultLabel(job) {
      if (job.status !== 'done') return null;
      if (job.type === 'import') {
        return job.appliedAt ? null : 'Проверить результат';
      }
      if (job.type === 'images') return 'Показать кандидатов';
      return null;
    },
    hasFailed(job) {
      return job.status === 'done' && model.failedItemIds(job).length > 0;
    },
  },
};
</script>

<style scoped lang="scss">
.spec-ai-indicator {
  display: flex;
  flex-direction: column;
  gap: 6px;

  &__job {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 14px;
    border-radius: 8px;
    background: #EEF6FF;
    font-size: 13px;

    &.error {
      background: #FFECEC;
    }
  }

  &__spinner {
    width: 14px;
    height: 14px;
    border: 2px solid var(--color-purple);
    border-top-color: var(--color-accent);
    border-radius: 50%;
    animation: spec-ai-spin 0.8s linear infinite;
  }

  &__action,
  &__dismiss {
    border: none;
    background: none;
    font: inherit;
    color: var(--color-accent);
    cursor: pointer;
    padding: 0;
  }

  &__dismiss {
    margin-left: auto;
    font-size: 18px;
    line-height: 1;
    color: var(--color-middle-gray);
  }
}

@keyframes spec-ai-spin {
  to { transform: rotate(360deg); }
}
</style>
